import { addMessageListener, connectWebSocket } from './websocket-utils'
import { updateAllBookingsState } from './booking-utils'

/**
 * Initialize WebSocket connection and set up message listeners
 */
export const initializeWebSocket = () => {
  // Connect to WebSocket
  connectWebSocket()
    .then(() => {
      console.log('Generic WebSocket connected')
    })
    .catch((e) => {
      console.error('WebSocket connection failed:', e)
    })

  // Set up appointment update listener
  addMessageListener('appointment', (data) => {
    switch (data.action) {
      case 'update':
        updateAllBookingsState(data.data)
        break
      default:
        console.log('Unhandled appointment action:', data.action)
    }
  })

  // Set up invoice communications listener
  addMessageListener('invoice_communications', (data) => {
    console.log('Invoice communications WebSocket message received:', data.action, data.data)
    // The individual components will handle their own updates
    // This is just for global logging/monitoring
  })
}

/**
 * Set up additional WebSocket message listeners
 * @param {string} type - Message type to listen for
 * @param {function} callback - Callback function to handle the message
 * @returns {function} Unsubscribe function
 */
export const setupMessageListener = (type, callback) => {
  return addMessageListener(type, callback)
}
